import Modal from "@/components/common/modal";
import { DialogFooter } from "@/components/ui/dialog";
import { Button } from "@elaniintc/goes-design-system";

interface Props {
  isOpen: boolean;
  isLoading?: boolean;
  onAccept: () => void;
  onClose: () => void;
}

const ActivateEmailTemplateModal = ({
  isOpen,
  isLoading,
  onAccept,
  onClose,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Activar plantilla"
      description="¿Estás seguro de que deseas activar esta plantilla? Se mostrará de la vista principal y podrás usar sus datos."
      modalContentClassName="max-w-[520px] w-full gap-7"
    >
      <DialogFooter className="pt-1">
        <div className="w-full grid grid-cols-1 tablet:grid-cols-2 gap-3">
          <Button
            size="lg"
            type="button"
            className="w-full rounded-lg"
            variant="tertiary"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <Button
            size="lg"
            variant="default"
            className="w-full rounded-lg"
            type="button"
            disabled={isLoading}
            onClick={onAccept}
            isLoading={isLoading}
          >
            Activar
          </Button>
        </div>
      </DialogFooter>
    </Modal>
  );
};

export default ActivateEmailTemplateModal;
